<div nz-row nzJustify="end" class="mobile-footer">
  <div nz-col>
    <table>
      <tbody>
        <tr>
          <td>
            <strong class="tax-amount left-align">Sub Total</strong>
          </td>
          @if (!isTaxInclusive){
            <td class="right-align">
              <span class="tax-amount">{{ (totalDebit! - totalTaxDebit! + totalWTaxDebit!) | currency: ' ' }}</span>
            </td>
            <td class="right-align">
              <span class="tax-amount">{{ (totalCredit! - totalTaxCredit! + totalWTaxCredit!)| currency: ' ' }}</span>
            </td>
          } @else {
            <td class="right-align">
              <span class="tax-amount">{{ (totalDebit! + totalWTaxDebit!) | currency: ' ' }}</span>
            </td>
            <td class="right-align">
              <span class="tax-amount">{{ (totalCredit! + totalWTaxCredit!) | currency: ' ' }}</span>
            </td>
          }
         
        </tr>
        <tr>
          <td>
            <span class="tax-amount left-align">
              <strong>Tax</strong>
            </span>
          </td>
          <td class="right-align">
            <span class="tax-amount">{{ totalTaxDebit | currency: ' '}}</span>
          </td>
          <td class="right-align">
            <span class="tax-amount">{{ totalTaxCredit | currency: ' '}}</span>
          </td>
        </tr>
        <tr [acl]="aclWtaxLineColumns">
          <td>
            <span class="tax-amount left-align">
              <strong>WTax</strong>
            </span>
          </td>
          <td class="right-align">
            <span class="tax-amount">{{ totalWTaxDebit | currency: ' '}}</span>
          </td>
          <td class="right-align">
            <span class="tax-amount">{{ totalWTaxCredit | currency: ' '}}</span>
          </td>
        </tr>

        <ng-container *ngIf="hideTotal">
          <tr>
            <td>
              <span class="total-amount total-amount-title left-align">Total</span>
            </td>
            <td class="amount-label" class="border-bottom-double">
              <span class="total-amount">{{ totalDebit | currencyWithSpace: currency}}</span>
            </td>
            <td class="amount-label" class="border-bottom-double">
              <span class="total-amount">{{ totalCredit | currencyWithSpace: currency}}</span>
            </td>
          </tr>
        </ng-container>
        <ng-container *ngIf="!hideTotal">
          <tr class="border-bottom-double">
            <td>
              <span class="total-amount total-amount-title left-align">Amount</span>
            </td>
            <td class="amount-label">
              <span class="total-amount">{{ totalDebit | currencyWithSpace: currency}}</span>
            </td>
            <td class="amount-label">
              <span class="total-amount">{{ totalCredit | currencyWithSpace: currency}}</span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>